module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1'), _vm._v(" "), _c('p', [_c('em', [_vm._v("Oh! I have slipped the surly bonds of Earth.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("And danced the skies on laughter-silvered wings;")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Sunward I’ve climbed, and joined the tumbling mirth")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Of sun-split clouds, and done a hundred things")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("You have not dreamed of wheeled and soared and swung")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("High in the sunlit silence. Hov’ring there,")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("I’ve chased the shouting wind along, and flung")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("My eager craft through footless halls of air.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("John Gillespie Magee, Jr 1941")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('em', [_vm._v("Flight 3456 standby, number 157 in sequence for start-up, call back tomorrow.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Delhi Air traffic control, 2013")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39322c3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 75
// module chunks = 0